import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-48fd3195"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "details_cz" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手动投料", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "details_dj" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_dj_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "details_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "生产点检")
], -1))
const _hoisted_8 = { class: "details_dj_list" }
const _hoisted_9 = { class: "details_dj_list_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_zw" }, null, -1))
const _hoisted_11 = { class: "details_footer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))

import { nextTick, onMounted, ref, reactive, getCurrentInstance } from 'vue'
    import { useRouter, useRoute } from "vue-router"
    import { queryById, getBarcodeContent, pageDJ, getListByCondition, deletedj } from '@/apis/WorkOrderAPI'
    import { Toast } from "vant"
    import { QRCodeType } from '@/enum'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy }: any = getCurrentInstance()
    const router = useRouter()
    const route = useRoute()

    // 详情数据
    let info: any = ref({})

    // 点检数据
    let djData: any = ref([])

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 分页查询数据
    let page = reactive({
        capacity: 10,
        page: 0
    })

    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);

    // 删除点检
    const dele = (id: string | number): void => {
        deletedj(id)
            .then(res => {
                if (res.code === 200) {
                    djData.value = []
                    finished.value = false
                    page.page = 0
                    pageDJs()
                }
            })
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        getBarcodeContent({
            barcode: data[0]
        }).then(res => {
            if (res.code === 200) {
                if (res.data.barcodeType === QRCodeType.GZ) {
                    getListByCondition({ id: res.data.id })
                        .then(gz => {
                            if (gz.code === 200) {
                                if (gz.data[0].status !== 1) {
                                    router.push({ name: 'codeScanningFeeding', query: { id: route.query.id, gzId: res.data.id } })
                                } else {
                                    Toast.fail({ message: '扫描的工装状态不能为空', duration: 2000 })
                                }
                            }
                        })
                } else {
                    Toast.fail({ message: '请扫描正确的篮筐码', duration: 2000 })
                }
            }
        })
        nextTick(() => {
            openCode.value = false
        })
    }

    // 跳转手动投料
    const jump = () => {
        router.push({ name: 'manualFeeding', query: { id: route.query.id } })
    }

    // 跳转扫码投料
    const jump1 = () => {
        openCode.value = true
    }

    // 跳转工单报工
    const jumpbg = () => {
        router.push({ name: 'workOrderReporting', query: { id: route.query.id } })
    }

    // 跳转点检
    const jumpdj = () => {
        router.push({ name: 'spotCheck', query: { id: route.query.id } })
    }

    // 获取详情数据
    const queryByIds = () => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    // 点检数据
    const pageDJs = () => {
        if (!finished.value) {
            page.page = page.page + 1
            loading.value = true
            pageDJ({
                capacity: page.capacity,
                page: page.page,
                model: {
                    workorderId: route.query.id
                }
            }).then(res => {
                if (res.code === 200 && res.data && res.data.records.length !== 0) {
                    djData.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
                loading.value = false
            }).catch(err => {
                loading.value = false
                finished.value = true
            })
        }
    }

    onMounted(() => {
        queryByIds()
        pageDJs()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(proxy).$auth('h5:workorderinput:create'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "details_cz_sdtl",
            onClick: jump
          }, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: pageDJs
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(djData), (item, index) => {
              return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
                right: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    square: "",
                    type: "danger",
                    style: {"height":"100%"},
                    onClick: ($event: any) => (dele(item.id)),
                    text: "删除"
                  }, null, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(item.attrName) + "：" + _toDisplayString(item.val), 1),
                    _createElementVNode("span", null, _toDisplayString(item.userName) + " " + _toDisplayString(item.createTime), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      (_unref(proxy).$auth('h5:workorder:processRecord'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "details_footer_buttona",
            onClick: jumpdj
          }, "生产点检"))
        : _createCommentVNode("", true),
      _hoisted_12,
      (_unref(proxy).$auth('h5:workorderoutput:confirm'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "details_footer_buttonb",
            onClick: jumpbg
          }, "工单报工"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})